export default __webpack_public_path__ + "f1bbfb8cba160a333506234bfd54fa9f.svg";